import Dexie from 'dexie';

export const db = new Dexie('ShopaliDB');

// Version fixe : 'id' sans ++ car l'API envoie des UUID (string)
db.version(1).stores({
  items: 'id, name, category, status, household_id, updated_at', 
  user: 'id, name, token, household_id' 
});